import { useEffect } from 'react';
// import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import createStore from 'react-auth-kit/createStore';
import AuthProvider from 'react-auth-kit';
import AuthOutlet from '@auth-kit/react-router/AuthOutlet';
import Header from './components/Header';
import Footer from './components/Footer';
import { Home, About, Recipients, Apply, Account, Application, Review, Success, TeamOreo, Faq, Rules, Legal } from './pages';
import './App.scss';
import AgeGate from './components/AgeGate';

// const RECAPTCHA_SITE_KEY = '6LePLrMrAAAAAAMJetfQXUJzFqslBi9oYhkMTy3L';

const store = createStore({
  // debug: true,
  authName:'_auth',
  authType:'cookie',
  cookieDomain: window.location.hostname,
  cookieSecure: window.location.protocol === 'https:',
  // refresh: refresh
});

const ScrollToTop = ()=>{
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <AuthProvider store={store} className="App">
      {/* <GoogleReCaptchaProvider
        reCaptchaKey={RECAPTCHA_SITE_KEY}> */}
        <Router>
          <ScrollToTop />
          <Header />
          <AgeGate />
          <Routes>
            {/* static pages */}
            <Route path="/" Component={Home} /> 
            <Route path="/about" Component={About} /> 
            <Route path="/recipients" Component={Recipients} /> 
            {/* <Route path="/apply" Component={Apply} /> */}
            {/* <Route path="/teamoreo" Component={TeamOreo} />  */}
            <Route path="/faq" Component={Faq} /> 
            <Route path="/rules" Component={Rules} /> 
            {/* login/account pages 
            <Route path="/login" Component={Account} />
            <Route path="/register" Component={Account} />
            <Route path="/recover" Component={Account} />
            <Route path="/confirm/:hash" Component={Account} />
            <Route path="/reset/:hash" Component={Account} />
            <Route element={<AuthOutlet fallbackPath='/login' />}>
              <Route path="/application" Component={Application} />
              <Route path="/review" Component={Review} />
              <Route path="/success" Component={Success} />
            </Route>
            {/* legal pages */}
            <Route path="/terms" Component={Legal} /> 
            <Route path="/privacy" Component={Legal} /> 
            <Route path="/cookies" Component={Legal} /> 
          </Routes>
          <Footer />
        </Router>
      {/* </GoogleReCaptchaProvider> */}
    </AuthProvider>
  );
}

export default App;
